import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useState } from "react";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { DimensionTypeCheckboxes } from "src/routes/bids/plan-based-bid-package/components/DimensionTypeCheckboxes";
import {
  buildDimensions,
  isBaseGroup,
  nextBaseGroupClientId,
  PlanBasedBidPackageFormState,
  renumberGroups,
} from "src/routes/bids/plan-based-bid-package/utils";

type BaseCostDimensionsModalProps = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
};

export function BaseCostDimensionsModal(props: BaseCostDimensionsModalProps) {
  const { formState, dimensionResults } = props;
  const { closeModal } = useModal();
  const baseGroup = formState.bidPlanGroups.rows.find((g) => isBaseGroup(g.value));
  const existingDimensions = baseGroup?.dimensions.value ?? [];
  const [selectedTypeIds, setSelectedTypeIds] = useState<string[]>(
    existingDimensions.map((d) => d.globalOptionTypeId).compact(),
  );

  function save() {
    const dimensions = buildDimensions(selectedTypeIds, existingDimensions, dimensionResults);
    if (baseGroup) {
      baseGroup.dimensions.set(dimensions);
    } else {
      const groups = formState.bidPlanGroups.value ?? [];
      formState.bidPlanGroups.set(
        renumberGroups([{ clientId: nextBaseGroupClientId(groups), order: 0, archive: false, dimensions }, ...groups]),
      );
    }
    closeModal();
  }

  return (
    <>
      <ModalHeader>Base Cost Dimension</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap3.$}>
          <div>
            Select cost dimensions that affect the base bid. Your selections create the cost lines in the base bid.
          </div>
          <DimensionTypeCheckboxes
            dimensionResults={dimensionResults}
            selectedTypeIds={selectedTypeIds}
            onChange={setSelectedTypeIds}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="tertiary" onClick={closeModal} />
        <Button label="Save" onClick={save} />
      </ModalFooter>
    </>
  );
}
